export const SET_TICKET_DETAIL = 'SET_TICKET_DETAIL';
export const SET_COMMENTARY_SECTIONS = 'SET_COMMENTARY_SECTIONS';
export const SET_WORKFLOW_STEPS = 'SET_WORKFLOW_STEPS';
export const SET_TAPE_DELIVERIES = 'SET_TAPE_DELIVERIES';
export const SET_TAPE_DELIVERY = 'SET_TAPE_DELIVERY';
export const SET_TAPE_CHANGE_TICKET_DETAIL = 'SET_TAPE_CHANGE_TICKET_DETAIL';
